/* eslint-disable no-unused-expressions */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react";
import Select from "react-select";
import ReactSummernote from "react-summernote";
import { Picker } from "emoji-mart";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { selectStyles } from "./styles";
import Emoji from "../../assets/img/icons/icon-emoji.svg";
import ButtonIcon from "../../assets/img/icons/icon-button.svg";
import * as communicationActions from "../../redux/actions/communicationActions";

import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/tooltip";

const mapDispatchToProps = {
  ...communicationActions,
};

const mapStateToProps = (state) => {
  const { workflows } = state;

  return {
    stateWorkflow: workflows,
  };
};

const validate = (values) => {
  const errors = {};

  if (!values.content || values.content === "<p><br></p>") {
    errors.content = "Required!";
  }

  return errors;
};

const Editor = ({
  stateWorkflow,
  event,
  smartFieldOptions,
  canSaveWorkflow,
  handlePatchWorkflowStep,
}) => {
  const eventWorkFlow = stateWorkflow[event];

  const workflow = eventWorkFlow.blocks.find(
    (b) => b.id === stateWorkflow.activeWorkflowId,
  );

  const [selected, setSelected] = React.useState(null);
  const [formErrors, setFormErrors] = React.useState({});
  const [showEmojiPicker, setShowEmojiPicker] = React.useState(false);

  const editorRef = React.useRef();
  const mounted = React.useRef(false);

  const runValidation = React.useCallback(() => {
    const errors = validate(workflow);

    setFormErrors(errors);
  }, [workflow]);

  const handleOnInit = React.useCallback(() => {
    const editArea = document.querySelector(".note-editable");

    const inline = `style="line-height: inherit; text-decoration: none; color: #ffffff; background: #0063FF; padding: 10px 20px; border-radius: 20px; margin-top: 20px; display: inline-block;"`;

    const anchorTagRegex = /<a/g;

    const result = workflow.content.replace(anchorTagRegex, `<a ${inline}`);

    editArea.innerHTML = result;
  }, [workflow]);

  const toggleShowEmojiPicker = React.useCallback(() => {
    setShowEmojiPicker(!showEmojiPicker);
  }, [showEmojiPicker, setShowEmojiPicker]);

  const onEmojiSelect = React.useCallback(
    (change) => {
      const { editor } = editorRef.current;

      editor.summernote("editor.restoreRange");
      editor.summernote("editor.focus");
      editor.summernote("editor.insertText", change.native);

      runValidation();

      canSaveWorkflow(event, workflow.id);

      toggleShowEmojiPicker();
    },
    [canSaveWorkflow, runValidation, event, workflow, toggleShowEmojiPicker],
  );

  const handleChange = React.useCallback(
    (html) => {
      let editorHtml = html;
      const anchorTagRegex = /<a href/g;
      const inline = `style="line-height: inherit; text-decoration: none; color: #ffffff; background: #0063FF; padding: 10px 20px; border-radius: 20px; margin-top: 20px; display: inline-block;"`;

      const hasLink = editorHtml.match(anchorTagRegex);

      if (hasLink !== null) {
        editorHtml = editorHtml.replace(anchorTagRegex, `<a ${inline} href`);

        const editArea = document.querySelector(".note-editable");

        editArea.innerHTML = editorHtml;
      }

      handlePatchWorkflowStep(stateWorkflow.activeWorkflowId, {
        content: editorHtml,
      });

      runValidation();
      canSaveWorkflow(event, workflow.id);
    },
    [
      handlePatchWorkflowStep,
      runValidation,
      canSaveWorkflow,
      event,
      workflow,
      stateWorkflow.activeWorkflowId,
    ],
  );

  const handleEditorSmartField = React.useCallback(
    (change) => {
      const { editor } = editorRef.current;

      editor.summernote("editor.restoreRange");
      editor.summernote("editor.focus");
      editor.summernote("editor.insertText", change.value);

      runValidation();
      canSaveWorkflow(event, workflow.id);

      setSelected(change.value);
    },
    [runValidation, canSaveWorkflow, event, workflow.id],
  );

  const handleAddButtonClick = React.useCallback(() => {
    const { editor } = editorRef.current;

    const button = `<a href="https://pushpress.com" style="line-height: inherit; text-decoration: none; color: #ffffff; background: #0063FF; padding: 10px 20px; border-radius: 20px; margin-top: 20px; display: inline-block;">Link</a>`;

    editor.summernote("editor.restoreRange");
    editor.summernote("editor.focus");
    editor.summernote("pasteHTML", button);
  }, []);

  const handleDocumentClick = (e) => {
    let isEmojiClassFound = false;

    e &&
      e.path &&
      e.path.forEach((elem) => {
        if (elem && elem.classList) {
          const data = elem.classList.value;
          if (data.includes("emoji")) {
            isEmojiClassFound = true;
          }
        }
      });
    if (isEmojiClassFound === false && e.target.id !== "emojis-btn") {
      setShowEmojiPicker(false);
    }
  };

  React.useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  React.useEffect(() => {
    if (mounted.current) {
      document.addEventListener("click", handleDocumentClick, false);
    }
    return () => {
      mounted.current = false;
    };
  });

  return (
    <div className="pp_trigger_edit_panel_block">
      <span className="pp_trigger_edit_panel_block_title">Body</span>
      <div
        className={`pp_trigger_edit_panel_subject_wrapper ${
          formErrors.content || stateWorkflow.errors.content
            ? "pp_trigger_edit_panel_block_input_error"
            : ""
        }`}
      >
        <div
          className="pp_trigger_edit_panel_subject_wrapper_part"
          id="toolbar"
        >
          <div
            className="pp_trigger_edit_panel_smart_field"
            style={{ width: "30%" }}
          >
            <Select
              className="pp_trigger_edit_panel_smart_field_select"
              key={`pp_body_smart_select__${selected}`}
              value={selected || ""}
              placeholder="Smart Fields"
              onChange={handleEditorSmartField}
              options={smartFieldOptions}
              styles={selectStyles}
            />
          </div>
          <div className="pp_trigger_edit_panel_controls_wrapper">
            <div className="pp_trigger_edit_panel_emoji_wrapper">
              <Emoji onClick={toggleShowEmojiPicker} />
              {showEmojiPicker && (
                <Picker onSelect={onEmojiSelect} set="apple" />
              )}
            </div>
          </div>
          <button
            onClick={handleAddButtonClick}
            type="button"
            className="pp_wysiwyg_add_button"
          >
            <ButtonIcon />
          </button>
        </div>
        <div className="pp_trigger_edit_panel_subject_wrapper_part pp_trigger_edit_panel_block_input no_padding">
          <ReactSummernote
            value={workflow.content}
            ref={editorRef}
            onInit={handleOnInit}
            options={{
              height: 350,
              dialogsInBody: true,
              disableResizeEditor: true,
              styleTags: ["p", "h1", "h2", "h3", "h4", "h5", "h6"],
              toolbar: [
                ["style", ["style"]],
                ["font", ["bold", "underline", "clear"]],
                ["para", ["ul", "ol", "paragraph"]],
                ["table", ["table"]],
                ["insert", ["link"]],
              ],
            }}
            onChange={handleChange}
          />
        </div>
      </div>
      {(formErrors.content || stateWorkflow.errors.content) && (
        <p className="pp_trigger_error">
          {formErrors.content || stateWorkflow.errors.content}
        </p>
      )}
    </div>
  );
};

Editor.propTypes = {
  event: PropTypes.string.isRequired,
  stateWorkflow: PropTypes.object.isRequired,
  smartFieldOptions: PropTypes.array.isRequired,
  handlePatchWorkflowStep: PropTypes.func.isRequired,
  canSaveWorkflow: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Editor);
